import React from 'react';
import styled from 'styled-components';
import { FormattedMessage, useIntl } from 'react-intl';

export const InfoContainer = styled.div.attrs(() => ({}))<{ visible: boolean }>`
  max-height: ${(props) => (props.visible ? '500px' : '0px')};
  opacity: ${(props) => (props.visible ? '1' : '0')};
  transition: 0.5s;
  width: 100%;
  font-size: 12px;
  margin-bottom: ${(props) => (props.visible ? '20px' : '10px')};
  overflow: hidden;
`;

export const InfoContent = (): JSX.Element => {
  const intl = useIntl();
  return (
    <>
      <p
        className="mb-1"
        dangerouslySetInnerHTML={{
          __html: intl.formatMessage({ id: 'dashboardPage.info.investableAmount' }),
        }}
      />
      <p
        className="mb-1"
        dangerouslySetInnerHTML={{
          __html: intl.formatMessage({ id: 'dashboardPage.info.payableAmount' }),
        }}
      />
      <p
        className="mb-1"
        dangerouslySetInnerHTML={{
          __html: intl.formatMessage({ id: 'dashboardPage.info.reservedAmount' }),
        }}
      />
      <p
        dangerouslySetInnerHTML={{
          __html: intl.formatMessage({ id: 'dashboardPage.info.balance' }),
        }}
      />
    </>
  );
};
